export default "__VITE_ASSET__B3U4jXVb__"